import getStateValue from '../../../../../../helpers/getStateValue';

const checkTestReseller = () => {
  const ecomDashCartScriptUrl = getStateValue('apiUrls.ecomDashCartScriptUrl') || '';

  return ecomDashCartScriptUrl.includes('mfeuat');
};

export default checkTestReseller;
